module.exports = __webpack_public_path__ + "img/time_line_circular_connect_head.2ce3c3ba.svg";